import * as Yup from 'yup';
import i18n from '../../../../../translations/strings';
export const ResetPasswordSchema = Yup.object({

  email: Yup.string()
      .lowercase()
      .required(i18n.t('common.requiredField'))
      .email(i18n.t('common.validEmail')),
});
